/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RunTransfer,
  RunTransfer$inboundSchema,
  RunTransfer$Outbound,
  RunTransfer$outboundSchema,
} from "./runtransfer.js";

export type RecurResponse = {
  /**
   *   RRule as defined by RFC 5545 (https://www.rfc-editor.org/rfc/rfc5545#section-3.3.10).
   *
   * @remarks
   *   Generators available online at the following sites - https://freetools.textmagic.com/rrule-generator, https://jkbrzt.github.io/rrule/
   */
  recurrenceRule: string;
  runTransfer: RunTransfer;
  /**
   * True if the RRule set runs indefinitely.
   */
  indefinite?: boolean | undefined;
  start?: Date | undefined;
};

/** @internal */
export const RecurResponse$inboundSchema: z.ZodType<
  RecurResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  recurrenceRule: z.string(),
  runTransfer: RunTransfer$inboundSchema,
  indefinite: z.boolean().optional(),
  start: z.string().datetime({ offset: true }).transform(v => new Date(v))
    .optional(),
});
/** @internal */
export type RecurResponse$Outbound = {
  recurrenceRule: string;
  runTransfer: RunTransfer$Outbound;
  indefinite?: boolean | undefined;
  start?: string | undefined;
};

/** @internal */
export const RecurResponse$outboundSchema: z.ZodType<
  RecurResponse$Outbound,
  z.ZodTypeDef,
  RecurResponse
> = z.object({
  recurrenceRule: z.string(),
  runTransfer: RunTransfer$outboundSchema,
  indefinite: z.boolean().optional(),
  start: z.date().transform(v => v.toISOString()).optional(),
});

export function recurResponseToJSON(recurResponse: RecurResponse): string {
  return JSON.stringify(RecurResponse$outboundSchema.parse(recurResponse));
}
export function recurResponseFromJSON(
  jsonString: string,
): SafeParseResult<RecurResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RecurResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RecurResponse' from JSON`,
  );
}
